import { TCoordinate } from '../../../packages/api-models/common/json_query';

export const coordsNumberToString = (coord: YMaps.TCoord): TCoordinate => [String(coord[0]), String(coord[1])];
